import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { prop } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import ZidIntegrationUpdateForm from '../../components/Zid/ZidIntegrationUpdateForm'
import { useIntegrationHistory, useZidDetail, useZidRemove, useZidUpdate } from '../../hooks'

function ZidIntegrationUpdateContainer () {
  const { tab } = useParams()
  const { guid } = useParams()

  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const messages = useMessages()
  const zidDetail = useZidDetail(guid)
  const zidUpdate = useZidUpdate(guid)
  const zidRemove = useZidRemove()

  const title = prop('name', zidDetail.detail)
  const type = prop('type', zidDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type: 'zid', tab: INTEGRATION_TABS.GENERAL })

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const handleSubmit = formValues =>
    zidUpdate.update(formValues)
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const isLoading = (
    zidDetail.isLoading ||
    zidUpdate.isLoading
  )

  const handleRemove = () =>
    zidRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      isLoading={zidDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <ZidIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={zidDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={zidDetail.detail}
        history={integrationHistory}
        type={type}
      />
    </DashboardLayout>
  )
}

export default ZidIntegrationUpdateContainer
